import axios from 'axios';
import { toastErrorMessage } from '../components/common/ToastMessage';
import { localStorageUtils } from '../utils/storageUtils';

const axiosService = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiVersion = process.env.REACT_APP_API_VERSION;

  const createAxiosInstance = (showToast: boolean = true) => {
    const instance = axios.create({
      baseURL: `${apiUrl}/${apiVersion}`,
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });

    instance.interceptors.request.eject(0); // Remove existing request interceptors
    instance.interceptors.response.eject(0); // Remove existing response interceptors

    instance.interceptors.response.use(responseInterceptor, (error) =>
      errorInterceptor(error, showToast),
    );

    return instance;
  };

  const errorInterceptor = async (
    error: {
      response: { data: { errors: any; message: string }; status: any };
      message: any;
      config: any;
    },
    showToast: boolean = true,
  ) => {
    if (!error.response) {
      localStorageUtils.clearSesssionItems();
    }

    if (showToast) {
      if (typeof error?.response?.data?.errors === 'string') {
        toastErrorMessage(`${error?.response?.data?.errors}`);
      } else if (typeof error?.response?.data?.errors === 'object') {
        const errorsArray = Object.values(error?.response?.data?.errors || {});
        errorsArray.forEach((message: any) => toastErrorMessage(message));
      } else if (typeof error?.response?.data?.message === 'string') {
        toastErrorMessage(`${error?.response?.data?.message}`);
      }
    }

    switch (error.response?.status) {
      case 401:
        localStorageUtils.clearSesssionItems();
        window.location.href = '/login';
        break;
      default:
        return Promise.reject(error);
    }
  };

  const responseInterceptor = (response: any) => {
    switch (response.status) {
      case 200:
        break;

      default:
    }

    return response;
  };

  const getGuestHttpClient = (showToast: boolean = true) => {
    return createAxiosInstance(showToast);
  };

  const getUserHttpClient = (options: any, showToast: boolean = true) => {
    const axiosInstance = createAxiosInstance(showToast);
    axiosInstance.defaults.responseType = options?.responseType ?? 'json';
    axiosInstance.interceptors.request.use(function (config) {
      // Do something before request is sent
      const accessToken = localStorage.getItem('attorney_registration_token');

      if (accessToken) {
        config.headers['Authorization'] = 'Bearer ' + accessToken;
      }
      return config;
    });
    return axiosInstance;
  };

  return { getGuestHttpClient, getUserHttpClient };
};

export default axiosService;
